import React from "react";
import { registerOverlay } from "../overlays";
import { useLang } from "../i18n";
import { emphasise } from "../emphasis";

export default function HeroOverlay() {
  const { t } = useLang();
  const h = t.hero;
  return (
    <section
      ref={(el) => registerOverlay("hero", el)}
      className="fixed inset-0 z-10 flex items-center"
      style={{ willChange: "opacity, transform" }}
    >
      <div className="mx-auto w-full max-w-[1200px] px-6 lg:px-10">
        {/* 57rem: the French headline is materially longer than the English.
            Sized so both set two lines at 1280 — see the note on hero type in
            DEVLOG. */}
        <div className="max-w-[57rem] mx-auto text-center">
          <p className="ff-mono text-xs uppercase tracking-[0.2em]" style={{ color: "var(--bb-red)" }}>
            {h.kicker}
          </p>
          <h1
            data-testid="hero-headline"
            className="mt-4 ff-head text-4xl sm:text-5xl lg:text-6xl leading-[1.06] tracking-[-0.025em]"
            style={{ color: "var(--bb-ink)" }}
          >
            {emphasise(h.headline[0], h.emphasis)}
            <br />
            {emphasise(h.headline[1], h.emphasis)}
          </h1>
          <p className="mt-6 mx-auto ff-serif text-[22px] sm:text-[27px] leading-[1.4] max-w-[38rem]" style={{ color: "var(--bb-ink-muted)" }}>
            {h.subhead}
          </p>
          {/* Nothing to click here on purpose. Asking before the reader knows
              what this is makes the ask the first impression; the scroll cue
              below is the only invitation, and the footer carries the form at
              the end of the story. */}
        </div>
      </div>
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2">
        <span className="ff-mono text-[10px] uppercase tracking-[0.2em]" style={{ color: "var(--bb-ink-faint)" }}>
          {h.scroll}
        </span>
        <span style={{ width: 1, height: 34, background: "rgba(245,240,232,0.28)" }} />
      </div>
    </section>
  );
}
